import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import CurrencyInput from 'react-currency-input-field'
import styles from './form.module.css'

// Assets
import saldoIcon from '../../assets/icono-saldo.png'

export const AmountInput = ({ name = 'amount', label = 'Monto', helpText = '', required = false }) => {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field, fieldState }) => (
        <div className={styles.field}>
          <label className={styles.label} htmlFor={name}>{label} {required && <span className={styles.required}>*</span>}</label>

          <div className={styles.shell}>
            <span className={styles.prefix}><img src={saldoIcon} alt="Saldo" height={17} /></span>
            <CurrencyInput
              autoFocus
              id={name}
              name={field.name}
              className={styles.input}
              value={field.value ?? ''}
              onBlur={field.onBlur}
              onValueChange={(value, _name, values) => {
                // Si se agrega desde autofill
                if (values?.float != null && Number.isFinite(values.float)) {
                  field.onChange(values.float)
                  return
                }
                field.onChange(value ?? '')
              }}
              placeholder="0.00"
              decimalsLimit={2}
              decimalSeparator="."
              groupSeparator=","
              allowNegativeValue={false}
              autoComplete="off"
              disableAbbreviations
            />
          </div>

          {fieldState.error && <p className={styles.error}>{fieldState.error.message}</p>}

          {helpText && <p className={styles.helpText}>{helpText}</p>}
        </div>
      )}
    />
  )
}